import React from 'react';
import { useTranslation } from 'react-i18next';
import Market from "../Market/Market";
import { imageAbsolutePath } from "../../utils/utils";
import LocalesImage from "../LocalesImage/LocalesImage";
import styles from './AppSection.module.css';

const google = imageAbsolutePath('googleBtn.svg');
const apple = imageAbsolutePath('appleBtn.svg');

const phoneDe: string = imageAbsolutePath('homePage/phone-de.png');
const phoneFr: string = imageAbsolutePath('homePage/phone-fr.png');
const phoneIt: string = imageAbsolutePath('homePage/phone-it.png');

const QRCode: string = imageAbsolutePath('qr-code.png');

const IMAGE_LIST = {
  de: { img: phoneDe },
  fr: { img: phoneFr },
  it: { img: phoneIt },
};

const AppSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section>
      <div className={styles.container}>
        <div className={styles.contentWrapper}>
          <h5>{t('homePage.appSection.title')}</h5>

          <p>{t('homePage.appSection.description')}</p>

          <div className={styles.buttonWrapper}>
            <Market src={google} alt="google" />
            <Market src={apple} alt="apple" />
            <img src={QRCode} width={100} alt="logo" />
          </div>
        </div>
        <div className={styles.imagesWrapper}>
          <LocalesImage
            alt={t('homePage.appSection.phoneImageAlt')}
            className={styles.phoneImage}
            localesPath={IMAGE_LIST}
          />
        </div>
      </div>
    </section>
  );
};

export default AppSection;
